import { render, staticRenderFns } from "./NovelGroupRenameDialog.vue?vue&type=template&id=3dc5f8e8&scoped=true"
import script from "./NovelGroupRenameDialog.vue?vue&type=script&lang=ts"
export * from "./NovelGroupRenameDialog.vue?vue&type=script&lang=ts"
import style0 from "./NovelGroupRenameDialog.vue?vue&type=style&index=0&id=3dc5f8e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc5f8e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dc5f8e8')) {
      api.createRecord('3dc5f8e8', component.options)
    } else {
      api.reload('3dc5f8e8', component.options)
    }
    module.hot.accept("./NovelGroupRenameDialog.vue?vue&type=template&id=3dc5f8e8&scoped=true", function () {
      api.rerender('3dc5f8e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/NovelGroupRenameDialog.vue"
export default component.exports